exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.components-wrap .active[data-v-4e59e616] {\n  border: 3px solid #ff5000;\n  opacity: 1;\n  box-shadow: 0 0 5px rgba(255, 80, 0, 0.3);\n  background: rgba(255, 80, 0, 0.2);\n  z-index: 999;\n  transition: all 0.3s ease;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4e59e616","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/view/pc/footerPage/default.vue
// module id = 1451
// module chunks = 0